<div class="form-modal program-details-modal resource-details-modern">
  <div class="program-detail-header">
    <div class="program-title-block">
      <div class="modal-eyebrow">{{ eyebrow }}</div>
      <h4 class="program-title">{{ title }}</h4>
      <div class="program-meta-row">
        <span class="status-badge" [ngClass]="isActive ? 'status-active' : 'status-inactive'">
          {{ status }}
        </span>
        <span class="meta-chip" *ngIf="subtitle">{{ subtitle }}</span>
        <span class="meta-chip" *ngIf="idLabel">ID: {{ idLabel }}</span>
      </div>
    </div>
    <button type="button" class="modal-close-btn" aria-label="Close" (click)="cancelModal()">
      <span>&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="program-detail-layout" [class.no-media-layout]="!showMediaPanel">
      <aside class="program-media-panel" *ngIf="showMediaPanel">
        <div class="program-image-frame" *ngIf="image; else noResourceImage">
          <img [src]="image" [alt]="title" (error)="onImageError($event)" />
        </div>
        <ng-template #noResourceImage>
          <div class="program-image-frame empty-media">
            <span>{{ getInitials(title) }}</span>
          </div>
        </ng-template>
      </aside>

      <section class="program-content-panel">
        <div class="stats-grid">
          <div class="stat-card" *ngFor="let stat of stats">
            <div class="stat-label">{{ stat.label }}</div>
            <div class="stat-value">{{ stat.value }}</div>
          </div>
        </div>

        <div class="detail-section" *ngIf="resourceType !== 'webinar' && resourceType !== 'dailyTask'">
          <div class="section-title">
            <span class="title-mark"></span>
            Overview
          </div>
          <p class="program-description">{{ description }}</p>
        </div>

        <div class="detail-section" *ngIf="resourceType === 'dailyTask'">
          <div class="section-title">
            <span class="title-mark"></span>
            Content by Language
          </div>
          <div class="language-detail-list">
            <div class="language-detail-card" *ngFor="let language of taskLanguageEntries">
              <div class="language-card-header">
                <span class="language-pill">{{ language.label }}</span>
                <span class="empty-language-pill" *ngIf="!language.hasContent">No copy added</span>
              </div>
              <div class="language-fields-grid">
                <div class="language-field full-width">
                  <div class="detail-label">Title</div>
                  <div class="detail-value strong-value">{{ language.title }}</div>
                </div>
                <div class="language-field full-width">
                  <div class="detail-label">Description</div>
                  <div class="detail-value">{{ language.description }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="detail-section" *ngIf="resourceType === 'webinar'">
          <div class="section-title">
            <span class="title-mark"></span>
            Content by Language
          </div>
          <div class="language-detail-list">
            <div class="language-detail-card" *ngFor="let language of webinarLanguageEntries">
              <div class="language-card-header">
                <span class="language-pill">{{ language.label }}</span>
                <span class="empty-language-pill" *ngIf="!language.hasContent">No copy added</span>
              </div>
              <div class="language-fields-grid">
                <div class="language-field">
                  <div class="detail-label">Title</div>
                  <div class="detail-value strong-value">{{ language.title }}</div>
                </div>
                <div class="language-field">
                  <div class="detail-label">Expert Name</div>
                  <div class="detail-value strong-value">{{ language.expertName }}</div>
                </div>
                <div class="language-field full-width">
                  <div class="detail-label">Description</div>
                  <div class="detail-value">{{ language.description }}</div>
                </div>
                <div class="language-field full-width">
                  <div class="detail-label">Expert Bio</div>
                  <div class="detail-value">{{ language.expertBio }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="detail-section" *ngIf="detailRows.length">
          <div class="section-title">
            <span class="title-mark"></span>
            More Details
          </div>
          <div class="details-list">
            <div class="detail-row" *ngFor="let detail of detailRows">
              <div class="detail-label">{{ detail.label }}</div>
              <a *ngIf="detail.isLink" class="detail-value detail-link" [href]="detail.value" target="_blank"
                rel="noopener noreferrer">
                {{ detail.value }}
              </a>
              <div *ngIf="!detail.isLink" class="detail-value">{{ detail.value }}</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" (click)="cancelModal()" class="btn btn-primary modal-size-btn">
      Close
    </button>
  </div>
</div>
